import React, { Component } from 'react';
import loadScripts from '../../../dassets/js/custom';
import { Link } from 'react-router-dom';

class FinancialAdvisory extends Component {
  componentDidMount() {
    loadScripts();
  }
  render() {
    return (
      <>
        {/* =================================
    Inner Header */}
        <div className="inner-header bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
                <h1 className="breadcrumb-title mb-0">Financial Advisory</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
                  <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
                  <li className="breadcrumb-item"><span>Services</span></li>
                  <li className="breadcrumb-item active"><span>Financial Advisory</span></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* =================================
  Inner Header */}


        <section className="space-ptb">
          <div className="container">
            <div className="row">
              <div className="col-md-4 col-xl-3">
                <ul className="list-unstyled vertical-menu border border-2 rounded p-3">
                  <li><Link to={"/services/issuing-house"}><span>Issuing House</span></Link></li>
                  <li><Link to={"/services/stockbroking"}><span>Stockbroking</span></Link></li>
                  <li><Link className="active" to={"/services/financial-advisory"}><span>Financial Advisory</span></Link></li>
                  <li><Link to={"/services/portfolio-management"}><span>Portfolio Management</span></Link></li>
                  <li><Link to={"/services/fund-management"}><span>Fund Management</span></Link></li>
                  <li><Link to={"/services/lagos-commodities-and-future-exchange"}><span>Lagos Commodities and Future Exchange</span></Link></li>
                </ul>
                <div className="bg-dark rounded p-4 mb-md-0 mb-5">
                  <span className="lead text-primary fw-bold">Do you have a question? Please contact us</span>
                  <h6 className="text-white mt-3">+(234) 0805 555 0606</h6>
                  <span className="text-white">info@dynamicportfolio.com</span>
                </div>
              </div>
              <div className="col-md-8 col-xl-9">
                {/* <img className="img-fluid mb-4" src={require("./../../dassets/images/service/10.jpg")} alt=""/> */}
                <div className="mb-md-5 mb-4">
                  <h4 className="mb-4">Financial Advisory</h4>
                  <div className='mb-4'>
                    <p>Dynamic Portfolio provides advisory services to meet our clients' needs in the area of corporate restructuring, mergers & acquisition, management -buy- out and privatization of government owned institutions. Our past experience in this area included merger between Inland Bank (Nig.) Plc and First Atlantic Bank Plc, merger between Custodian & Allied Insurance Ltd, Fire Equity & General Insurance Ltd and Signal Insurance Co. Ltd and acquisition of Niger Delta Petroleum Resources Ltd and Chemur Ltd's entire working interest in Ogbele JV by Niger Delta Exploration & Production Plc, among others.</p>
                  <p>These include:</p>
                  <ul className="list">
                <li><i className="far fa-circle"></i> Project Finance and Development</li>
                <li><i className="far fa-circle"></i> Mergers and Acquisitions</li>
                <li><i className="far fa-circle"></i> Corporate Restructuring/Reorganisation</li>
              </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default FinancialAdvisory;